/* eslint-disable max-statements */
/* eslint-disable camelcase */
/* eslint-disable new-cap */

import React from 'react';
import {Button, Card, Dropdown, Icon, Label, Popup} from 'semantic-ui-react';
import {customValuesVehiclesDates} from '../../utils/commonUtils';
import ColorIcon from '../commons/colorIcon';
import {handleExcelReport} from '../../../common/components/commercialTable/exportUtils/handleExport';
import {filterPriorizationOptions, filterPriorizationVehTypeOptions} from '../../constants/filterPriorizationOptions';
import {scopes} from '../../../common/permissions/dictionary';
import {datesType, priorizationType} from '../../constants/selectTypes';
import {Actions} from '../../../common/actions';
import {useDispatch} from 'react-redux';

const {
  fetchPriorizationCombos,
} = Actions;

const Header = ({
  selectMode,
  setSelectMode,
  filters,
  setFilters,
  setVehTypeFilters,
  filteredData,
  columns,
  setOpenUpdateDates,
  selectedData,
  setSelectedData,
  isUserTDE,
  dropDownTypeOptions,
  dropDownTypeValue,
  setDropDownTypeOptions,
  setDropDownTypeValue,
  dropDownOptions,
  dropDownValue,
  setDropDownOptions,
  setDropDownValue,
  userType,
  setSelectType,
  setDropDownValueBill,
  dropDownValueBill,
}) => {
  const dispatch = useDispatch();
  const handleExportToExcel = (event) => {
    event.preventDefault();
    const excelRows = filteredData.map((row) => {
      return row.original;
    });
    handleExcelReport(excelRows, columns, customValuesVehiclesDates);
  };
  return (
    <Card fluid>
      <div className="title-bar center-vertical">
        <div className="title center-vertical">
          <div className="priorization-header-title">
            <h2 className='priorization-title-text'>
              Producción de vehículos
            </h2>
            <Label className="total priorization-dates-count-chip" color="red">
              {'Total Vehículos'}
              <Label.Detail>{filteredData?.length || 0}</Label.Detail>
            </Label>
            <Popup
              position='bottom left'
              size='small'
              inverted
              style={{'width': 130}}
              trigger={
                <Icon name='info circle' color='blue' className='no-space pointer' size='mini'/>
              }>
              {
                <div>
                  <p>Código de colores fechas</p>
                  <table>
                    <tr>
                      <td><ColorIcon color={'#A3C0F8'} /></td>
                      <td>Planificado</td>
                    </tr>
                    <tr>
                      <td><ColorIcon color={'#f8d0a3'} /></td>
                      <td>En proceso</td>
                    </tr>
                    <tr>
                      <td><ColorIcon color={'#AAF8A3'} /></td>
                      <td>Finalizado</td>
                    </tr>
                    <tr>
                      <td><ColorIcon color={'#F8A3A3'} /></td>
                      <td>Con atraso</td>
                    </tr>
                  </table>
                </div>
              }
            </Popup>
          </div>
          <div className="title-bar-actions">
            <Dropdown
              placeholder="Seleccionar estado"
              selection
              value={dropDownValueBill} // Valor seleccionado
              onChange={(e, {value}) => {
                setDropDownValueBill(value); // Actualiza el valor seleccionado
              }}
              options={[
                {'key': 'facturados', 'text': 'Facturados', 'value': 'facturados'},
                {'key': 'noFacturados', 'text': 'No Facturados', 'value': 'noFacturados'},
              ]}
              className="priorization-selector-header"
              style={{'width': '80px'}}
            />
          </div>
          <div className="title-bar-actions">
            <Dropdown
              placeholder='TODO'
              selection
              value={dropDownTypeValue}
              onChange={(e, {value}) => {
                if (value) {
                  setVehTypeFilters({
                    'vehTypeFilterKey': value,
                    'vehTypeFilterValue': null,
                  });
                } else {
                  setVehTypeFilters(null);
                  setDropDownTypeOptions(filterPriorizationVehTypeOptions);
                  setDropDownTypeValue('');
                }
              } }
              options={dropDownTypeOptions}
              className='priorization-selector-header'
            />
            <Dropdown
              placeholder='TODO'
              selection
              disabled={selectMode}
              value={dropDownValue}
              onChange={(e, {value}) => {
                if (value) {
                  setFilters({
                    'filterKey': value,
                    'filterValue': null,
                  });
                } else {
                  setFilters(null);
                  setDropDownOptions(filterPriorizationOptions);
                  setDropDownValue('');
                }
              } }
              options={dropDownOptions}
              className='priorization-selector-header'
            />
            {selectMode ?
              <>
                <Button
                  type="button"
                  basic
                  className="toyota-secondary"
                  onClick={() => {
                    setSelectMode(false);
                    setSelectType(null);
                    setSelectedData([]);
                    setFilters(null);
                    setDropDownOptions(filterPriorizationOptions);
                    setDropDownValue('');
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  disabled={!selectedData?.length}
                  primary
                  color='red'
                  onClick={() => {
                    dispatch(fetchPriorizationCombos(
                      selectedData[0].reservationId,
                      selectedData[0].masterCode,
                      selectedData[0].sfx
                    ));
                    setOpenUpdateDates(true);
                  }}
                >
                  Continuar
                </Button>
              </> :
              <>
                <Button
                  disabled={!filteredData.length}
                  primary
                  color='red'
                  onClick={handleExportToExcel}
                >
                  Exportar
                </Button>
                {isUserTDE &&
                  <Button
                    primary
                    color='red'
                    onClick={() => {
                      setSelectType(datesType);
                      setSelectMode(true);
                      setFilters({
                        'filterKey': 'available',
                        'filterValue': null,
                      });
                    }}
                    disabled={dropDownValueBill === 'facturados'}
                  >
                    Ajustar
                  </Button>
                }
                {
                  (userType === scopes.LogisticEdit || userType === scopes.SalesEdit) && (
                    <Button
                      primary
                      color='red'
                      onClick={() => {
                        setSelectMode(true);
                        setSelectType(priorizationType);
                        setFilters({
                          'filterKey': 'notPrioritized',
                          'filterValue': null,
                        });
                      }
                      }
                      disabled={dropDownValueBill === 'facturados'} // Deshabilitar si es 'facturados'
                    >
                      Priorizar
                    </Button>
                  )
                }
              </>
            }
          </div>
        </div>
      </div>
    </Card>
  );
};

export default Header;
